'use strict'
import "angular"
export * from "./angular_1_router"
export * from "./decorators";